export default __webpack_public_path__ + "static/media/watch1.1f81e9c1.jpg";